// extracted by mini-css-extract-plugin
module.exports = {"tableScrollWrapper":"Table_tableScrollWrapper__28L3p","table":"Table_table__3ykLE","textValue":"Table_textValue__9H1tN"};